import React, { useState, useEffect, } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams, } from "react-router-dom";
import {
  Card,
  CardBody,
} from "../../../_metronic/_partials/controls";
import * as actions from "./_redux/Actions";
import { NotificationContainer, NotificationManager } from "react-notifications";

import moment from "moment";
import { Formik, } from "formik";
import './ContestList.css';
import * as UIHelpers from "../../components/UIHelpers";
import helperFunc from "../../../_metronic/_helpers/helperFunc";

export default function RoomIdPassword(props) {
  const dispatch = useDispatch();

  const [idText, setIdText] = useState('');
  const [passwordText, setPasswordText] = useState('');
  const [isDisabled, setIsdisabled] = useState(false);
  const { id } = useParams();
  const contestData = props.contestData
  const formate = 'YYYY-MM-DD h:m A';

  const saveIdPassword = (values) => {

    let gameContestTime = moment(contestData?.data?.matchTime).format(formate)
    let gameIdPassUpdateTime = moment(contestData?.data?.matchTime)
      .add(contestData?.data?.gameTypeAry?.settings?.RPTime, 'minutes')
      .format(formate)

    let item = {}
    item._id = id
    item.roomId = idText
    item.roomPassword = passwordText

    if(idText != "" && idText != null && passwordText != "" && passwordText != null)
    {
      dispatch(actions.setContestIdPassword(item)).then((sucess) => sucess ? reloadLocation() : null);
    }
    else
    {
      NotificationManager.error('Please enter room id and password', 'Error');
    }
  };

  useEffect(() => {
    let today = new Date();
    let gameContestTime = new Date(contestData?.data?.matchTime);
    let gameIdPassUpdateTime = new Date(contestData?.data?.matchTime);

    gameContestTime = subtractMinutes(15, gameContestTime);
    gameIdPassUpdateTime = subtractMinutes(15, gameIdPassUpdateTime);

    gameIdPassUpdateTime = new Date(gameIdPassUpdateTime.getTime() - contestData?.data?.gameTypeAry?.settings?.RPTime * 60 * 1000)
    let now = moment().format(formate)
  }, [contestData])

  const reloadLocation = () => {
    window.location.reload();
  };

  function subtractMinutes(numOfMinutes, date = new Date()) {
    const dateCopy = new Date(date.getTime());

    dateCopy.setMinutes(dateCopy.getMinutes() - numOfMinutes);

    return dateCopy;
  }

  let today = new Date();
  let gameContestTime = new Date(contestData?.data?.matchTime);
  let gameIdPassUpdateTime = new Date(contestData?.data?.matchTime);
  gameContestTime = subtractMinutes(15, gameContestTime);
  gameIdPassUpdateTime = subtractMinutes(15, gameIdPassUpdateTime);

  gameIdPassUpdateTime = new Date(gameIdPassUpdateTime.getTime() - contestData?.data?.gameTypeAry?.settings?.RPTime * 60 * 1000)


  return (
      <>
      <NotificationContainer />
      {helperFunc.isButtonAccess('contest.roomID&RoomPassword.other') ?
      <Card className="card_border">
        <div className="card-header p-0">
          <div className="my-5 row mx-0 px-4 w-100 d-flex justify-content-between">
            <div className="" style={{ fontSize: '24px', fontWeight: '600' }}>Room ID / Password</div>
          </div>
        </div>

        <CardBody className="p-2">

          <div className="form-group row m-2">
            <div className="col p-2" style={{ maxWidth: '250px', }}>
              <label> ID</label>
              <input
                type="text"
                className="form-control"
                placeholder="ID"
                value={idText}
                disabled={isDisabled}
                onChange={(e) => { setIdText(e.target.value) }}
              />
            </div>

            <div className="col p-2" style={{ maxWidth: '250px', }}>
              <label> Password</label>
              <input
                type="text"
                className="form-control"
                placeholder="Password"
                value={passwordText}
                disabled={isDisabled}
                onChange={(e) => { setPasswordText(e.target.value) }}
              />
            </div>

            <div className="justify-content-end  col p-2">

              {
                <button type="submit" className="btn btn-dark"
                  style={{ margin: '26px', }}
                  onClick={() => { saveIdPassword() }}
                >
                  Save
                  {/* Search */}
                </button>
                // :
                // <></>
              }
            </div>
          </div>
        </CardBody>
      </Card>
      :
      <></>
      }
      </>
  )
}